import { getIconPathByRiskRule } from '@silverfort-nodelibs/common/utils/insight';

import domainIcon from './Images/Inventory/domains.svg';
import ouIcon from './Images/Inventory/ous.svg';
import groupIcon from './Images/Inventory/groups.svg';
import userIcon from './Images/Inventory/users.svg';
import serverIcon from './Images/Inventory/servers.svg';
import appsIcon from './Images/Inventory/apps.svg';
import oktaIcon from './Images/Inventory/okta.svg';

const nameToIconsMapper = {
    domains: domainIcon,
    ous: ouIcon,
    groups: groupIcon,
    users: userIcon,
    servers: serverIcon,
    azureapps: appsIcon,
    oktaapps: oktaIcon
};

export function getIconBySectionAndName(section, name) {
    if (section === 'INVENTORY_ITEMS' && nameToIconsMapper[name]) {
        return nameToIconsMapper[name];
    }
    return getIconFromIconPath(getIconPathByRiskRule(name, true));
}

export function getIconFromIconPath(iconPath) {
    return iconPath;
}
